import { jsxs as o, jsx as l } from "react/jsx-runtime";
const t = (h) => /* @__PURE__ */ o(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    ...h,
    children: [
      /* @__PURE__ */ l("path", { fill: "currentColor", d: "M33.608 54.503h-.001v.001-.001Z" }),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M32 5.407c-5.534 0-10.037 4.502-10.037 10.036a9.652 9.652 0 0 0 2.976 6.964v4.04c0 .613.369 1.168.918 1.415l2.045 29.315h6.207l-.795-2.966h-2.646L28.84 27.997h6.32l-1.828 26.209 3.03-.812 1.78-25.532a1.56 1.56 0 0 0 .919-1.415v-4.04a9.652 9.652 0 0 0 2.976-6.964C42.037 9.91 37.534 5.407 32 5.407Zm0 2.966a7.086 7.086 0 0 1 6.867 5.4H25.133A7.086 7.086 0 0 1 32 8.373Zm4.095 17.267h-8.19v-2.325h8.19v2.325Zm.1-4.681h-8.39a6.82 6.82 0 0 1-2.733-4.22h13.855a6.819 6.819 0 0 1-2.732 4.22Z"
        }
      )
    ]
  }
);
export {
  t as Comedy
};
